import { render, staticRenderFns } from "./modal-image.vue?vue&type=template&id=43c0792f"
import script from "./modal-image.vue?vue&type=script&lang=js"
export * from "./modal-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports